function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "489CE6B0-D3E2-4F38-8EBB-BA5C2F25EA5F@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-608.000000, -768.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit",
  transform: "translate(608.000000, 768.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "symbol",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4641016,26.660254 L9,28.1243557 L7.53589838,22.660254 L18.5358984,3.60769515 C19.0881831,2.65110991 20.3113639,2.3233596 21.2679492,2.87564435 L24.7320508,4.87564435 C25.6886361,5.4279291 26.0163864,6.65110991 25.4641016,7.60769515 L14.4641016,26.660254 Z M18.2678984,8.0713612 L9.68208317,22.940953 L10.4145,25.6743698 L13.1456848,24.941819 L21.7318984,10.0713612 L18.2678984,8.0713612 Z M20.2679492,4.60769515 L19.2678984,6.3393612 L22.7318984,8.3393612 L23.7320508,6.60769515 L20.2679492,4.60769515 Z"
})))));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.0f68141d.svg";
export { ForwardRef as ReactComponent };